import React from "react";
import { ReactComponent as More } from "../../../../svg/arrow_right_com.svg";

const RecommendCard = ({ id, list, onSetOneFood }) => {
  const meals = list.recommendMeals;

  return (
    <div className="mt-3 space-y-2">
      {meals &&
        meals.map((meal) => (
          <div
            id={id}
            key={meal.id}
            className={
              "rounded-xl px-3 py-2.5 " +
              (meal.mealType.includes("S")
                ? "bg-[#E6F0FC] "
                : meal.mealType === "B"
                ? "bg-yellow_10 "
                : meal.mealType === "L"
                ? "bg-orange_10 "
                : "bg-green_10 ") +
              (meal.detailList?.length > 0 ? "block" : "hidden")
            }
          >
            {meal.detailList?.length > 0 ? (
              <>
                <h1 className="mb-1.5 text-black text-base font-semibold">
                  {meal.mealType.includes("S")
                    ? "Snack"
                    : meal.mealType === "B"
                    ? "Breakfast"
                    : meal.mealType === "L"
                    ? "Lunch"
                    : "Dinner"}
                </h1>
                <ul className="flex flex-col gap-2">
                  {meal.detailList.map((detail) => (
                    <div key={detail.id} className="flex items-center gap-2">
                      <span className="text-xl leading-none">
                        {detail.rice === 2
                          ? "🍚"
                          : detail.soup === 2
                          ? "🍲"
                          : detail.protein === 2
                          ? "🍖"
                          : detail.vegetable === 2
                          ? "🥗"
                          : detail.kimchi === 2
                          ? "🥬"
                          : detail.snack === 2
                          ? "🍎"
                          : "🍎"}
                      </span>
                      <div
                        onClick={() => {
                          // 음식클릭 GA 이벤트
                          window.dataLayer.push({
                            event: "view_food_name",
                            food_id: detail.foodId,
                            food_name: detail.foodName,
                          });

                          onSetOneFood(
                            detail.id,
                            detail.foodId,
                            meal.mealDate,
                            meal.mealType
                          );
                        }}
                        className="flex items-start justify-between flex-1 p-2.5 bg-white rounded-lg"
                      >
                        <div className="flex flex-col gap-0.5 flex-1 min-w-0">
                          <h2 className="text-black text-[15px] font-medium break-words leading-tight">
                            {detail.foodName}
                          </h2>
                          <p className="text-xs text-gray_100">
                            {detail.eyemesurementnumber}{" "}
                            {detail.eyemesurementunit}
                          </p>
                        </div>
                        <More
                          fill={
                            meal.mealType.includes("S")
                              ? "#5AC2E4"
                              : "#417FFF"
                          }
                          className="w-4 h-4 flex-shrink-0 mt-0.5"
                        />
                      </div>
                    </div>
                  ))}
                </ul>
              </>
            ) : (
              ""
            )}
          </div>
        ))}
    </div>
  );
};

export default RecommendCard;
